import { API } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getProjectById } from '@/service/projectService';

export const resolveVoiceCallTargetName = async (callTarget, fallbackName = '') => {
    const projectId = Utils.getPrefixOfId(callTarget) === Constant.ID_PREFIX.PROJECT
        ? callTarget
        : `${callTarget || ''}`.match(/project_[0-9a-fA-F-]{36}/)?.[0];
    if (!projectId) {
        return fallbackName || '';
    }

    const projectDetail = await getProjectById(API, projectId);
    const projectName = Utils.getTextByLanguage(
        Constant.LANGUAGE_TYPE.JP,
        projectDetail?.name
    );
    return projectName || fallbackName || '';
};

const getProjectTargetIds = (projectTarget) => {
    if (Array.isArray(projectTarget)) {
        return projectTarget.filter(Boolean);
    }
    if (typeof projectTarget === 'string') {
        const parsedProjectTarget = Utils.convertJSONDataToObject(projectTarget);
        if (Array.isArray(parsedProjectTarget)) {
            return parsedProjectTarget.filter(Boolean);
        }
        return projectTarget
            .split(',')
            .map(projectId => projectId.trim())
            .filter(Boolean);
    }
    return [];
};

const isSingleVoiceTicketBetweenUserAndProject = (metaData = {}) => {
    const fromPrefix = Utils.getPrefixOfId(metaData?.from || '');
    const toPrefix = Utils.getPrefixOfId(metaData?.to || '');
    return [fromPrefix, toPrefix].includes(Constant.ID_PREFIX.USER)
        && [fromPrefix, toPrefix].includes(Constant.ID_PREFIX.PROJECT);
};

export const isVoiceCallTicketAvailableInProject = (
    metaData = {},
    ticketData = {},
    currentProject = {}
) => {
    const currentProjectId = currentProject?.id || '';
    if (!currentProjectId) return false;

    if (ticketData?.affiliationProject === currentProjectId) return true;
    if (ticketData?.projectOrigin === currentProjectId) return true;
    if (getProjectTargetIds(ticketData?.projectTarget).includes(currentProjectId)) return true;
    if ([metaData?.from, metaData?.to].includes(currentProjectId)) return true;

    return currentProject?.type === Constant.PROJECT_TYPE.BASE
        && isSingleVoiceTicketBetweenUserAndProject(metaData)
        && Utils.getPrefixOfId(ticketData?.customer || '') === Constant.ID_PREFIX.USER;
};

export const resolveVoiceCallTarget = (metaData = {}, ticketData = {}, currentProjectId = '') => {
    const from = metaData?.from || '';
    const to = metaData?.to || '';

    if (from === currentProjectId && to) return to;
    if (to === currentProjectId && from) return from;

    if (Utils.getPrefixOfId(ticketData?.customer) === Constant.ID_PREFIX.PROJECT
        && ticketData.customer !== currentProjectId) {
        return ticketData.customer;
    }

    const projectTarget = getProjectTargetIds(ticketData?.projectTarget)
        .find(projectId => projectId && projectId !== currentProjectId);
    if (projectTarget) {
        return `${projectTarget}`.match(/project_[0-9a-fA-F-]{36}/)?.[0] || projectTarget;
    }

    if (ticketData?.projectOrigin && ticketData.projectOrigin !== currentProjectId) {
        return ticketData.projectOrigin;
    }

    return to || from || '';
};
